import { PermissionAction } from '@viterbit/web-app/dataAccess/model/PermissionAction.model'
import i18n from '@viterbit/web-app/i18n'
import AsideCardInfo from '@viterbit/web-app/shared/display/AsideCardInfo'
import IsGranted from '@viterbit/web-app/shared/permission/IsGranted'
import * as React from 'react'

import DeleteLeavePolicy from './DeleteLeavePolicy'

const DeletePoliciesAction = ({ leavePolicy }: any) => (
    <IsGranted
        id={leavePolicy.id}
        action={PermissionAction.CORE_HR_LEAVE_POLICIES_DELETE}
    >
        <AsideCardInfo className='mb-4' title={i18n.t('settingLeaves:dangerZone')}>
            <DeleteLeavePolicy
                leavePolicy={leavePolicy}
                id={leavePolicy.id}
            />
        </AsideCardInfo>
    </IsGranted>
)


export default DeletePoliciesAction
